import { AppBar, DialogActions, DialogContent, IconButton, TextField, Toolbar, Typography } from '@material-ui/core';
import XAPPButton from 'app/Core/Components/Button/XAPPButton';
import XAPPDialog from 'app/Core/Components/Dialog/XAPPDialog';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import MobileDetect from 'mobile-detect';
import React from 'react';
import { MdClose } from 'react-icons/md';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import * as Actions from '../Store/Actions/EmpresaFinanceiroActions';
import EmpresaFinanceiroBaixaDialog from "./EmpresaFinanceiroBaixaDialog";

const md = new MobileDetect(window.navigator.userAgent);

class EmpresaFinanceiroDetalheDialog extends XAPPComponent {

    state = {
        open: null
    };

    componentDidUpdate(prevProps) {
        const { open, getDetalhes, xappRouteParams } = this.props;
        if (prevProps.open === null && open !== null) {
            var Condition = [{ "Campo": "idtarefaprocessoapontamentoitemgrupo", "Operador": "=", "Valor": open.idtarefaprocessoapontamentoitemgrupo }]
            getDetalhes(xappRouteParams, Condition);
        }
    }

    openDialog = (_AValue) => {
        this.setState({ open: _AValue });
    }

    callbackActions = () => {
        const { open, getDetalhes, xappRouteParams } = this.props;
        var Condition = [{ "Campo": "idtarefaprocessoapontamentoitemgrupo", "Operador": "=", "Valor": open.idtarefaprocessoapontamentoitemgrupo }]
        getDetalhes(xappRouteParams, Condition);
    }

    render() {
        const { save, detalhes, filter, open, openDialog, xappRouteParams, parametros } = this.props;
        const form = this.state;
        return (
            <XAPPDialog
                id="FinanceiroDetalhes"
                open={open !== null}
                onClose={() => openDialog(null)}
                fullWidth
                fullScreen={md.mobile() !== null}
                maxWidth="sm"
            >
                <AppBar position="static" elevation={1}>
                    <Toolbar className="flex w-full min-h-0">
                        <Typography variant="subtitle1 text-white">
                            {'Detalhes do grupo'}
                        </Typography>
                        <div style={{ flex: 1 }} />
                        <IconButton
                            key="close"
                            aria-label="Close"
                            className="p-6"
                            onClick={() => openDialog(null)}
                        >
                            <MdClose className="text-20 text-white" />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <DialogContent classes={{ root: "p-24" }}>
                    {detalhes !== null &&
                        <React.Fragment>
                            <TextField
                                className="mb-12"
                                id="idtarefaprocessoapontamentoitemgrupo"
                                name="idtarefaprocessoapontamentoitemgrupo"
                                label="ID"
                                value={detalhes.idtarefaprocessoapontamentoitemgrupo}
                                variant="outlined"
                                fullWidth
                                disabled
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                            <TextField
                                className="mb-12"
                                id="observacao"
                                name="observacao"
                                label="Observações"
                                value={detalhes.observacao}
                                variant="outlined"
                                fullWidth
                                disabled
                                multiline
                                rows={3}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                            <TextField
                                className="mb-12"
                                id="valortotal"
                                name="valortotal"
                                label="Valor total"
                                value={"R$ " + detalhes.valortotal}
                                variant="outlined"
                                disabled
                                fullWidth
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                            <TextField
                                className="mb-12"
                                id="selecteds"
                                name="selecteds"
                                label="Quantidade de titulos"
                                value={detalhes.selecteds.split(",").length}
                                variant="outlined"
                                disabled
                                fullWidth
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </React.Fragment>
                    }
                </DialogContent>
                <AppBar position="static" elevation={3} color="textSecondary">
                    <Toolbar className="flex w-full justify-end min-h-0">
                        <DialogActions>
                            <XAPPButton
                                type="Button"
                                className="bg-green hover:bg-green text-white mr-8"
                                onClick={(ev) => {
                                    save("DESFAZERGRUPO", detalhes, xappRouteParams, filter);
                                    openDialog(null);
                                }}
                                variant="contained"
                                iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                icon={'layerfill'}
                                label={md.mobile() === null && md.tablet() === null ? 'DESAGRUPAR' : ''}
                                key={"btnDesfazer"}
                            />
                            <XAPPButton
                                type="Button"
                                className="bg-green hover:bg-green text-white"
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    this.openDialog(detalhes);
                                }}
                                iconProps={"mr-8"}
                                icon={detalhes !== null && detalhes.status === 'pendente' ? 'cifrao' : 'return'}
                                label={detalhes !== null && detalhes.status === 'pendente' ? 'Baixar' : 'Estornar'}
                            />
                        </DialogActions>
                    </Toolbar>
                </AppBar>
                <EmpresaFinanceiroBaixaDialog
                    open={form.open}
                    openDialog={this.openDialog}
                    xappRouteParams={xappRouteParams}
                    parametros={parametros}
                    filter={filter}
                    callback={this.callbackActions}
                />
            </XAPPDialog>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getDetalhes: Actions.getDetalhes,
        save: Actions.save,
    }, dispatch);
}

function mapStateToProps({ EmpresaFinanceiro }) {
    return {
        detalhes: EmpresaFinanceiro.detalhes,
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EmpresaFinanceiroDetalheDialog));
